import {
  Backdrop,
  Box,
  Button,
  Grid,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BCPXmark } from "../../../components/icons/bcp/BCPIcons";
import { Formik } from "formik";
import { postNotification } from "../../../components/utilities/Notifications";
import { handlePagingAll } from "../../../components/api/APIUtilities";
import * as Yup from "yup";
import { postData } from "../../../components/utilities/UtilityFunctions";
import ScorecardPicker from "../../../components/utilities/ScorecardPicker";

export default function SwapScorecardModal(props) {
  const { sCMenuOpen, setSCMenuOpen, authContext, event, pairing } = props;

  const [scorecards, setScorecards] = useState(null);
  const [teamScorecards, setTeamScorecards] = useState(null);
  const [scorecardDict, setScorecardDict] = useState({});

  useEffect(() => {
    const fetchScorecards = async (gsystem) => {
      let filters = {
        gameSystemId: gsystem?.id,
      };
      if (authContext?.authState?.identity?.userId) {
        filters.ownerId = authContext?.authState?.identity?.userId;
      } else {
        filters.public = true;
      }
      if (gsystem?.boardGameEvent) {
        filters.type = "SeatedPairing";
      }

      try {
        const apiScorecards = await handlePagingAll("/scorecards", filters);

        let apiScorecardDict = {};

        let foundCurrent = false;
        let scorecardArray = [];

        let foundTeamCurrent = false;
        let teamScorecardArray = [];

        apiScorecards.forEach((scorecard) => {
          apiScorecardDict[scorecard.id] = scorecard;
          if (event) {
            if (event?.scorecardId === scorecard.id) {
              foundCurrent = true;
            }
            if (event?.teamScorecardId === scorecard.id) {
              foundTeamCurrent = true;
            }
          }

          if (
            scorecard.type === "Pairing" ||
            scorecard.type === "SeatedPairing"
          ) {
            scorecardArray.push({
              value: scorecard.id,
              label: scorecard.name,
              default: gsystem?.scorecardId === scorecard.id,
              current: event?.scorecardId === scorecard.id,
              scorecardType: scorecard.scorecardType,
            });
          } else if (scorecard.type === "TeamPairing") {
            teamScorecardArray.push({
              value: scorecard.id,
              label: scorecard.name,
              default: gsystem?.teamScorecardId === scorecard.id,
              current: event?.teamScorecardId === scorecard.id,
              scorecardType: scorecard.scorecardType,
            });
          }
        });

        if (
          !foundCurrent &&
          event?.scorecardId &&
          event?.scorecardId !== gsystem?.scorecardId
        ) {
          scorecardArray.push({
            value: event?.scorecardId,
            label: event?.scorecard?.name || event?.name,
            current: true,
            scorecardType: event?.scorecard?.scorecardType,
          });
        }

        if (
          !foundTeamCurrent &&
          event?.teamScorecardId &&
          event?.teamScorecardId !== gsystem?.teamScorecardId
        ) {
          teamScorecardArray.push({
            value: event?.teamScorecardId,
            label: event?.teamScorecard?.name || event?.name,
            current: true,
            scorecardType: event?.teamScorecard?.scorecardType,
          });
        }

        scorecardArray.sort((a, b) => {
          if (a.default) return -1;
          if (b.default) return 1;
          if (a.current) return -1;
          if (b.current) return 1;
          var nameA = a.label.toLowerCase();
          var nameB = b.label.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
        setScorecards(scorecardArray);

        teamScorecardArray.sort((a, b) => {
          if (a.default) return -1;
          if (b.default) return 1;
          if (a.current) return -1;
          if (b.current) return 1;
          var nameA = a.label.toLowerCase();
          var nameB = b.label.toLowerCase();
          if (nameA > nameB) return 1;
          if (nameA < nameB) return -1;
          return 0;
        });
        setTeamScorecards(teamScorecardArray);

        setScorecardDict(apiScorecardDict);
      } catch (err) {
        postNotification("error", err);
      }
    };

    fetchScorecards(event?.gameSystem);
    // eslint-disable-next-line
  }, []);

  async function swapScorecard(id) {
    try {
      const apiScorecard = await postData(
        `/pairings/${pairing?.id}/swapScorecard`,
        {
          scorecardId: id,
          pairingType: pairing?.pairingType,
        }
      );

      if (apiScorecard) {
        postNotification("success", "Scorecard changed successfully");
        setTimeout(() => {
          window.location.reload();
        }, [1500]);
      }
    } catch (err) {
      postNotification("error", err);
    }
  }

  return (
    <Modal
      disableAutoFocus
      open={Boolean(sCMenuOpen)}
      onClose={() => {
        setSCMenuOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ zIndex: 9999 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          bgcolor: "modal.background",
          color: "modal.text",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setSCMenuOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>

        <Formik
          enableReinitialize={true}
          initialValues={{
            eventType: event?.doublesEvent
              ? "Doubles Event"
              : event?.teamEvent
                ? "Teams Event"
                : "Singles Event",
            pairingType: pairing?.pairingType || "",
            scorecardId:
              pairing?.scorecardId ||
              pairing?.scorecard?.id ||
              event?.scorecardId ||
              event?.gameSystem?.scorecardId ||
              "",
            teamScorecardId:
              event?.teamScorecardId ||
              event?.gameSystem?.teamScorecardId ||
              "",
            matchWinsForTie:
              event?.matchWinsForTie !== undefined ? event.matchWinsForTie : 0,
            marginOfVictoryForTie:
              event?.marginOfVictoryForTie !== undefined
                ? event.marginOfVictoryForTie
                : 0,
          }}
          validationSchema={Yup.object().shape({
            scorecardId: Yup.string().required("Required"),
            teamScorecardId: event?.teamEvent
              ? Yup.string().required("Required")
              : null,
          })}
          onSubmit={async (values) => {
            if (values.pairingType !== "TeamPairing") {
              delete values.teamScorecardId;
            }

            if (values.pairingType === "TeamPairing" && !event?.doublesEvent) {
              delete values.scorecardId;
            }

            if (
              values?.scorecardId &&
              values?.scorecardId !== pairing?.scorecard?.id
            ) {
              await swapScorecard(values?.scorecardId);
            } else if (
              values?.teamScorecardId &&
              values?.teamScorecardId !== pairing?.scorecard?.id
            ) {
              await swapScorecard(values?.teamScorecardId);
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            touched,
            values,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={2}
                sx={{
                  pb: 1,
                  mb: 2,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h4" component="h2">
                    Change Scorecards
                  </Typography>
                </Grid>

                {values?.pairingType === "TeamPairing" &&
                  !event?.doublesEvent && (
                    <>
                      <Grid item xs={12}>
                        <ScorecardPicker
                          name="teamScorecardId"
                          label="Team Scorecard"
                          value={values.teamScorecardId}
                          handleChange={(e) => {
                            if (
                              scorecardDict?.[e.target.value]?.variables
                                ?.length > 0
                            ) {
                              let variables =
                                scorecardDict[e.target.value].variables;
                              for (let variable of variables) {
                                if (values[variable.id] === undefined) {
                                  setFieldValue(
                                    variable.id,
                                    variable.default !== undefined
                                      ? variable.default
                                      : 0
                                  );
                                }
                              }
                            }

                            handleChange(e);
                          }}
                          scorecards={teamScorecards}
                          inclAny={false}
                          error={Boolean(
                            touched.teamScorecardId && errors.teamScorecardId
                          )}
                          helperText={
                            touched.teamScorecardId && errors.teamScorecardId
                          }
                        />
                      </Grid>
                    </>
                  )}

                {(values?.pairingType === "Pairing" ||
                  values?.pairingType === "SeatedPairing" ||
                  (values?.pairingType === "TeamPairing" &&
                    event?.doublesEvent)) && (
                  <Grid item xs={12}>
                    <ScorecardPicker
                      name="scorecardId"
                      label="Scorecard"
                      value={values.scorecardId}
                      handleChange={handleChange}
                      scorecards={scorecards}
                      inclAny={false}
                      error={Boolean(touched.scorecardId && errors.scorecardId)}
                      helperText={touched.scorecardId && errors.scorecardId}
                    />
                  </Grid>
                )}

                <Grid item xs={6}>
                  <Button
                    color="error"
                    fullWidth
                    variant="outlined"
                    onClick={() => {
                      setSCMenuOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="success"
                    fullWidth
                    variant="contained"
                    type="submit"
                    disabled={
                      values?.pairingType === "TeamPairing" &&
                      values?.teamScorecardId &&
                      values?.teamScorecardId !== pairing?.scorecard?.id
                        ? false
                        : (values?.pairingType !== "TeamPairing" ||
                              (values?.pairingType === "TeamPairing" &&
                                event?.doublesEvent)) &&
                            values?.scorecardId &&
                            values?.scorecardId !== pairing?.scorecard?.id
                          ? false
                          : true
                    }
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}
